<script lang="ts">
    import { _ } from "svelte-i18n";
    import { Alert } from "sveltestrap";
    import { appManager } from "../../AppManager";
    import type { OrganizationPlan } from "@anyways-open/identity-api-client";

    let expired: boolean = false;
    let active: boolean = true;
    let expiredPlan: OrganizationPlan;
    let showAsTrial: boolean = false;

    const checkExpiredPlan = async () => {
        const planState = await appManager.getPlanState()

        // if the user has an active plan for any of their organizations things are fine.
        // otherwise we show the first expired plan.

        expired = planState.hasExpiredPlan() && !planState.hasActivePlan()
        // TODO: open this up once we have support for plans on all organizations.
        // active = planState.hasActivePlan();
        const expiredPlans = planState.expiredPlans
        if (expiredPlans.length > 0) {
            expiredPlan = expiredPlans[0]
        }

        active = planState.hasActivePlan()

        // if the only active plan is a trial, we show the alert too.
        if (
            planState.activePlans.length == 1 &&
            planState.activePlans[0].plan.key === "trial"
        ) {
            showAsTrial = true
            //console.log("trial")
        }
    };
</script>

{#await checkExpiredPlan() then}
    <Alert
        color="danger"
        isOpen={expired || !active || showAsTrial}
        class="rounded-0 w-100 mb-0 py-1">
        <div class="container w-100" style="z-index: unset;">
            <div class="row">
                <div class="col-12 g-0">
                    <div class="text-center text-sm">
                        {#if expired}
                            {#if expiredPlan.plan.key === "trial"}
                                {$_("alert.planExpired.trial")}
                            {:else}
                                {$_("alert.planExpired.general")}
                            {/if}
                        {:else if !active}
                            {$_("alert.planExpired.noplan")}
                        {:else if showAsTrial}
                            {$_("alert.planExpired.trialActive")}
                        {/if}
                        {$_("alert.planExpired.checkpricing.part1")}<a
                            href={`${appManager.RootUrl}pricing`}
                            target="_blank"
                            >{$_("alert.planExpired.checkpricing.part2")}</a
                        >{$_("alert.planExpired.checkpricing.part3")}
                    </div>
                </div>
            </div>
        </div>
    </Alert>
{/await}
